export const UI_MODE = {
  MCAT: 'mcat',
  DAT: 'dat',
};
